import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { StockTransferMatch } from 'app/models/inventory/adjustmentFormView';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { BaseFormService } from '../BaseFormService';
import { UtilityService } from '../utility.service';

@Injectable({
	providedIn: 'root',
})
export class AdjustmentFormService extends BaseFormService {
	constructor(httpClient: HttpClient, utilityService: UtilityService) {
		super(`${environment.apiUrl}inventory/clients/$$clientId$$/adjustment-form`, httpClient, utilityService);
	}
	submitForApproval(clientId: string, id: any, userId: string): Observable<any> {
		return this.httpClient
			.post<any>(`${this.getUrl(clientId)}/${id}/approval`, {
				userId,
			})
			.pipe();
	}
	/** EN-4353: for each item on a Transfer, the item at the new location it would move into, or why it can't. */
	getTransferMatches(
		clientId: string,
		request: { locationId: string; transferredLocationId: string; itemIds: string[] }
	): Observable<StockTransferMatch[]> {
		return this.httpClient.post<StockTransferMatch[]>(`${this.getUrl(clientId)}/transfer-matches`, request);
	}
	/** EN-4353: the journal entry a Transfer would post, estimated at current cost. Approval posts it from the lots that move. */
	getTransferJournalPreview(
		clientId: string,
		request: { locationId: string; transferredLocationId: string; items: { itemId: string; newQuantity: number }[] }
	): Observable<any[]> {
		return this.httpClient.post<any[]>(`${this.getUrl(clientId)}/transfer-journal-preview`, request);
	}
}
